import React from 'react';

function EPReportBug() {
  return (
    <div>EPReportBug</div>
  );
}

export default EPReportBug;
